export const FormFields = {
    SEVERITY: 'severity',
};
